import { graphql } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { TitleSectionFragment } from "@queries/fragments/TitleSectionFragment";
import { ListItemFragment } from "@queries/fragments/ListItemFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

export const GetEditorialPageById = graphql(
  `
    query GetEditorialPageById(
      $id: String!
      $locale: String
      $preview: Boolean
    ) {
      editorialPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        hero {
          variant
          title
          subtitle
          description
          ctaText
          ctaLink
          backgroundImage {
            url
            contentType
          }
          previewVideo {
            url
            contentType
          }
          fullVideo {
            url
            contentType
          }
          overlayImage {
            url
          }
          eyebrowImagesCollection {
            items {
              url
              contentType
            }
          }
          bodyRichText {
            ...RichEntryFragment
          }
          fullWidthImage {
            url
            contentType
          }
        }
        sectionTitle {
          ...TitleSectionFragment
        }
        description {
          title
          descriptionRichText { json }
        }
        list {
          _id
          viewMoreText
          itemsCollection(limit: 30) {
            total
            items {
              ...ListItemFragment
            }
          }
        }
        routing {
          sys {
            id
          }
          variant
          isVertical
          title
          titleRichText {
            json
          }
          cta {
            ...LinkFragment
          }
          backgroundImage {
            url
            title
          }
        }
      }
    }
  `,
  [RichEntryFragment, LinkFragment, TitleSectionFragment, ListItemFragment, ThemeFragment, MetadataFragment]
);
